var map = {
	"./dice.webp": 1682,
	"./esports-bg.webp": 1683,
	"./esports-ctg.webp": 1684,
	"./im-img.webp": 1685,
	"./im-title-cn.webp": 1686,
	"./im-title-en.webp": 1687,
	"./snooker.webp": 1688,
	"./spade.webp": 1689,
	"./tfg-img.webp": 1690,
	"./tfg-title-cn.webp": 1691,
	"./tfg-title-en.webp": 1692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1681;